import React, { useState } from "react";

import { makeLinkApiService, type LinkApiService } from "api";
import { LinkApiServiceContext } from "./ServiceContext";

export const LinkApiServiceProvider: React.FC<React.PropsWithChildren> = (
  props
) => {
  const [service] = useState<LinkApiService>(makeLinkApiService());

  return (
    <LinkApiServiceContext.Provider value={service}>
      {props.children}
    </LinkApiServiceContext.Provider>
  );
};
